import _ from 'lodash';
import { createSelector } from 'reselect';

import datastore from '@datastore';

import { NAMESPACES } from './index';

const { isMessageFeatureEnabled } = datastore.selectors.company;

// eslint-disable-next-line import/prefer-default-export
export const getAccessibleNamespaces = createSelector(
  isMessageFeatureEnabled,
  messengerEnabled =>
    _.filter(
      NAMESPACES,
      namespace => _.isEqual(NAMESPACES.MESSAGING, namespace) && messengerEnabled,
    ),
);
